<template>
  <sb-banner v-if="hasAnyErrors" class="errors" variation="danger">
    <div class="errors__header">
      <p v-if="headerMessage">
        {{ headerMessage }}
      </p>
      <sb-anchor
        v-if="hasMultipleErrors"
        @click.prevent="toggleErrors"
      >
        <p class="errors__view-all">
          View All
          <span
            class="icon icon-chevron-left errors__expand-icon"
          />
        </p>
      </sb-anchor>
    </div>
    <div v-if="showMultipleErrors">
      <li v-for="error in errors" :key="error.message">
        {{ error.message }}
      </li>
    </div>
    <div v-else-if="!hasMultipleErrors">
      <!-- Only 1 error to show by default -->
      <p v-for="error in errors" :key="error.message">
        {{ error.message }}
      </p>
    </div>
  </sb-banner>
</template>
<script>
export default {
  name: 'ErrorMessages',
  props: {
    errors: {
      type: Array,
      required: true
    },
    headerMessage: {
      type: String,
      required: false,
      default: 'One or more errors occurred.'
    }
  },
  data: () => ({
    showMultipleErrors: false
  }),
  computed: {
    hasAnyErrors () {
      return this.errors.length > 0
    },
    hasMultipleErrors () {
      return this.errors.length > 1
    }
  },
  methods: {
    toggleErrors () {
      this.showMultipleErrors = !this.showMultipleErrors
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/shipbob-custom/_mixins.scss';

.errors {
  text-align: left;

  &__header {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }

  &__view-all {
    color: $color-primary;
  }

  &__expand-icon {
    transform: rotate(-90deg);
    display: inline-flex;
  }
}
</style>
